import {donateMobileState} from "../../inline-donation/DonateMobileState";
import {DonateHomeDonateComponent, DonateHomeDonateComponentStyle} from "../donate/DonateHomeDonateComponent";
import {styleRuleInherit} from "../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";


class DonateHomeEditDonationComponentStyle extends DonateHomeDonateComponentStyle {
    @styleRuleInherit
    title = {
        display: "none",
    }
}

@registerStyle(DonateHomeEditDonationComponentStyle)
export class DonateHomeEditDonationComponent extends DonateHomeDonateComponent {
    updateDonation() {
        donateMobileState.donationAmount = donateMobileState.getTotalAmount();
        donateMobileState.donatePageUpdateDonation(this.options.changeURL);
    }
}
